import type { OpEntityTable, OpKind, TaskId, MockCache, ActivityEvent } from '../types';

import { newId } from './ids';
import { idxPush } from './indexes';
import { takeActivitySeq } from './runtime';

interface LogInput {
  mutator: string;
  entityTable: OpEntityTable;
  entityId: string;
  op: OpKind;
  before: Record<string, unknown> | null;
  after: Record<string, unknown> | null;
  taskIds?: TaskId[];
}

export function logActivity(cache: MockCache, input: LogInput): ActivityEvent {
  const me = cache.users.get(cache.me);
  const taskIds = input.taskIds ?? (input.entityTable === 'task' ? [input.entityId as TaskId] : []);
  const event: ActivityEvent = {
    id: newId('activity') as ActivityEvent['id'],
    seq: takeActivitySeq(),
    at: cache.nowMs(),
    actorId: cache.me,
    actorKind: me?.kind ?? 'human',
    mutator: input.mutator,
    entityTable: input.entityTable,
    entityId: input.entityId,
    op: input.op,
    before: input.before,
    after: input.after,
    reversible: true,
    batchId: null,
    taskIds,
  };
  cache.activity.push(event);
  for (const taskId of taskIds) {
    idxPush(cache.index.activityByTask, taskId, event.id);
  }
  return event;
}
